import { memo } from "react";
import type { GridRowParams } from "@mui/x-data-grid";
import { MenuItem } from "consts/openBanking";
import { useIbanXSBanksRecipientsPivotActions } from "features/openBanking/actions";
import { DeleteOpenBankingResource } from "../../shared/OpenBankingResource";

const DeleteIbanXSBanksRecipientsPivot = (props: GridRowParams) => {
    const { deleteIbanXSBanksRecipientsPivot } = useIbanXSBanksRecipientsPivotActions();

    const deleteOpenBankingResource = async ({ row }: GridRowParams) => {
        const [request] = deleteIbanXSBanksRecipientsPivot(row, {
            shouldNotifyOnSuccess: true
        });
        await request;
    };

    return (
        <DeleteOpenBankingResource
            {...props}
            menuItem={MenuItem.IbanXSBanksRecipientsPivot}
            deleteOpenBankingResource={deleteOpenBankingResource}
            ModalProps={{
                titleSlot: `Delete ID=${props.row.coreId} Iban XS Banks Recipients Pivot`,
            }}
        >
            Are you sure you want to delete this Iban XS Banks Recipients Pivot?
        </DeleteOpenBankingResource>
    );
};

export default memo(DeleteIbanXSBanksRecipientsPivot);
